import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUrlGenerator } from '@ngrx/data';
import { Update } from '@ngrx/entity';
import { TagInterface } from '@shared/api';
import { Observable } from 'rxjs';
import { CustomDefaultDataService } from '../custom-default-data-service.class';
import { EntityTypeEnum } from '../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class TagsDataService extends CustomDefaultDataService<TagInterface> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super(EntityTypeEnum.Tag, http, httpUrlGenerator);
  }

  override update(update: Update<TagInterface>): Observable<TagInterface> {
    return this.http.patch(`${this.entityUrl}${update.id}`, update.changes, {
      headers: {
        'Content-type': 'application/merge-patch+json',
      },
    }) as Observable<TagInterface>;
  }
}
